import { render } from "./NewsShowModal.vue?vue&type=template&id=1b3ea55b&scoped=true"
import script from "./NewsShowModal.vue?vue&type=script&lang=js"
export * from "./NewsShowModal.vue?vue&type=script&lang=js"

import "./NewsShowModal.vue?vue&type=style&index=0&id=1b3ea55b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3ea55b"]])

export default __exports__